import { Dialog, DialogActions, DialogContent, DialogTitle, useTheme } from "@mui/material";
import { Grid } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { Spinner } from "../external/ensolvers-core-frontend-mui/components/Common/Spinner";
import { BooleanSegmented } from "./SegmentedControl";
import { ButtonComponent } from "./ButtonComponent";
import { Token } from "../theme";
import { AppEditDrawer } from "./AppEditDrawer";

interface ButtonLabel {
  label: string;
  onClick: () => void;
}

interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
  content: JSX.Element;
  buttons?: ButtonLabel[];
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  hideCancel?: boolean;
  isLoading?: boolean;
  toggle?: boolean;
  setActive?: Dispatch<SetStateAction<boolean>>;
  active?: boolean;
  asDrawer?: boolean;
  contextLabel?: string;
  consequence?: string;
}

export const AppDialog = ({
  open,
  onClose,
  title,
  content,
  buttons,
  maxWidth,
  hideCancel = false,
  isLoading,
  toggle,
  setActive,
  active,
  asDrawer = false,
  contextLabel,
  consequence,
}: Props) => {
  const theme = useTheme();

  const handleChangeActivePositions = () => {
    setActive?.(!active);
  };
  if (asDrawer) {
    return (
      <AppEditDrawer
        open={open}
        onClose={onClose}
        title={title}
        content={content}
        buttons={buttons}
        hideCancel={hideCancel}
        isLoading={isLoading}
        contextLabel={contextLabel}
        consequence={consequence}
      />
    );
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth={maxWidth}>
      {isLoading ? (
        <>
          <Grid sx={{ minWidth: "46.3em", height: "13.1em" }}>
            <Spinner />
          </Grid>
        </>
      ) : (
        <>
          <Grid display={"flex"} justifyContent={"space-evenly"} alignItems={"center"}>
            <DialogTitle style={{ color: Token.textPrimary, marginBottom: -10, marginTop: 10 }}>{title}</DialogTitle>
            {toggle && (
              <Grid display={"flex"} justifyContent={"space-evenly"} alignItems={"center"}>
                <BooleanSegmented
                  checked={active}
                  onToggle={handleChangeActivePositions}
                  offLabel="All positions"
                  onLabel="Active only"
                  ariaLabel="Active positions only"
                />
              </Grid>
            )}
          </Grid>

          <DialogContent>{content}</DialogContent>

          <DialogActions>
            {!hideCancel && <ButtonComponent onClick={onClose} text={"Cancel"} />}

            {buttons?.map((button, index) => (
              <ButtonComponent
                key={`${button.label}-${index}`}
                debounce
                onClick={button.onClick}
                text={button.label}
                style={{ color: Token.actionPrimary }}
              />
            ))}
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};
